import { SET_CURRENT_USER, SET_USERS } from "../constants/actionTypes";

const initialState = {
  currentUser: null,
  users: [],
};

function users(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      const settingsConfig = window.Social.getSettingsConfig();
      let currentUser = action.currentUser;
      if (
        settingsConfig.userSimulation &&
        currentUser[settingsConfig.userSimulationPath[0]]
      ) {
        currentUser.login = currentUser[settingsConfig.userSimulationPath[0]];
        for (let i = 1; i < settingsConfig.userSimulationPath.length; i++) {
          currentUser.login =
            currentUser.login[settingsConfig.userSimulationPath[i]];
        }
      }
      return {
        ...state,
        currentUser: action.currentUser,
      };
    case SET_USERS:
      return {
        ...state,
        users: action.users,
      };
    default:
      return state;
  }
}

export default users;
